import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a contract icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ContractIcon width={12} />
 */
const ContractIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M39.455,2.467H8.331a4.413,4.413,0,0,0-4.4,4.4v35.2a4.413,4.413,
            0,0,0,4.4,4.4H39.455a4.36,4.36,0,0,0,2.52-.807h.007v-.005a4.4,4.4,0,
            0,0,1.874-3.588V6.867A4.413,4.413,0,0,0,39.455,2.467ZM37.328,
            30.118l-11.2,11.2a.976.976,0,0,1-.709.3,1.009,1.009,0,0,
            1-.728-.3l-5.6-5.6a.958.958,0,0,1,0-1.388l1.388-1.388a.959.959,
            0,0,1,1.388,0l3.54,3.54,9.1-9.143a.959.959,0,0,1,1.388,0l1.388,
            1.388A.921.921,0,0,1,37.328,30.118Zm-1.551-7.651H12.009a2,2,0,1,
            1,0-4H35.778a2,2,0,1,1,0,4Zm0-8H12.009a2,2,0,1,1,0-4H35.778a2,
            2,0,1,1,0,4Z`}
        />
    </SvgIcon>
)

ContractIcon.defaultProps = defaultProps

export { ContractIcon }
